import { IDepartureTimeRange, IFilters } from ".";
import { IFlight } from "redux/searchForm";

export const initialFiltersState: IFilters = {
  baggageAllowance: {
    touched: false,
    included: true,
    notIncluded: true,
  },
  travellerTypes: {
    touched: false,
    ordinary: true,
    studentsAndYouth: true,
  },
  stops: {
    touched: false,
    direct: true,
    oneStop: true,
    twoPlusStops: true,
  },
  departureTime: {
    touched: false,
    departureTimeRanges: [
      {
        departure: [0, 1440],
        arrival: [0, 1440],
        showDeparture: true,
      },
      {
        departure: [0, 1440],
        arrival: [0, 1440],
        showDeparture: true,
      },
    ],
  },
  maxDurations: {
    touched: false,
    maxDurations: [2880, 2880],
  },
  preferredAirlines: { touched: false, airlines: [] },
  allAirlines: [],
};

export const initialDepartureTimeRangeObj: IDepartureTimeRange = {
  departure: [0, 1440],
  arrival: [0, 1440],
  showDeparture: true,
};

export const initialFlightObj: IFlight = {
  arrival: null,
  departure: null,
  departureDate: null,
  validation: {
    arrival: {
      dirty: false,
      valid: false,
    },
    departure: {
      dirty: false,
      valid: false,
    },
    departureDate: {
      dirty: false,
      valid: false,
    },
  },
};
